(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-gift-nightgrid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function money(c) { return '$' + (c / 100).toFixed(2); }
    function asJson(r) {
      if (!r.ok) return r.text().then(function (t) { throw new Error(t || r.statusText); });
      return r.json();
    }

    function rowVariant(row) {
      var v = row.querySelector('[data-ng-variant]');
      return v ? v.value : null;
    }
    function rowPrice(row) {
      var p = row.querySelector('[data-ng-line]');
      if (!p) return 0;
      return Math.round(parseFloat(String(p.textContent).replace(/[^0-9.]/g, '')) * 100) || 0;
    }

    /* Tổng ĐỦ ĐIỀU KIỆN: mọi dòng TRỪ dòng quà. Quà không nằm trong collection
       điều kiện của mã, nên cộng nó vào là vẽ sai ngưỡng cho khách. */
    function recalc(root) {
      var sum = 0;
      root.querySelectorAll('[data-ng-row]').forEach(function (row) {
        if (row.hasAttribute('data-ng-free')) return;
        sum += rowPrice(row);
      });

      var thresh = parseInt(root.getAttribute('data-ng-thresh'), 10) || 0;
      var need = thresh - sum;

      var t = root.querySelector('[data-ng-total]');
      if (t) t.textContent = money(sum);

      var box = root.querySelector('[data-ng-need]');
      var amt = root.querySelector('[data-ng-need-amt]');
      if (box) box.hidden = need <= 0;
      if (amt && need > 0) amt.textContent = money(need);
      return sum;
    }

    function submit(root) {
      var msg = root.querySelector('[data-ng-msg]');
      var btn = root.querySelector('[data-ng-go]');
      var cartUrl = root.getAttribute('data-ng-cart');
      var giftId = root.getAttribute('data-ng-gift-id');
      var giftPrice = parseInt(root.getAttribute('data-ng-gift-price'), 10) || 0;

      function stop(text) {
        if (msg) { msg.textContent = text; msg.hidden = false; }
        if (btn) btn.disabled = false;
      }
      function go() { window.location.href = cartUrl; }

      if (msg) msg.hidden = true;
      if (btn) btn.disabled = true;

      var items = [];
      root.querySelectorAll('[data-ng-row]').forEach(function (row) {
        var id = rowVariant(row);
        if (id) items.push({ id: Number(id), quantity: 1 });
      });
      /* Dòng quà PHẢI được đẩy vào giỏ ở đây. Shopify không tự thêm — đã đo. */
      if (giftId) items.push({ id: Number(giftId), quantity: 1 });

      if (!items.length) { stop('Nothing to add.'); return; }

      fetch(root.getAttribute('data-ng-add') + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(asJson)
        .then(function () {
          return fetch(cartUrl + '.js', { credentials: 'same-origin' }).then(asJson);
        })
        .then(function (cart) {
          /* KHÔNG suy từ giá hiển thị. Hỏi thẳng Shopify: dòng quà đã được
             giảm đủ giá của nó chưa. Không đủ thì cảnh báo, tuyệt đối không
             im lặng đẩy khách sang giỏ với một lời hứa đã hỏng. */
          var line = (cart.items || []).filter(function (i) {
            return String(i.variant_id) === String(giftId);
          })[0];

          var off = 0;
          if (line && line.line_level_discount_allocations) {
            line.line_level_discount_allocations.forEach(function (a) { off += a.amount; });
          }

          if (line && off >= giftPrice) { go(); return; }
          stop('Your items are in the cart, but the free gift did not apply. ' +
               'Please review your cart before checking out.');
        })
        .catch(function (e) { stop(e.message || 'Could not add to cart. Please try again.'); });
    }

    /* Khách đổi biến thể ở form chính phía trên -> dòng đầu chạy theo.
       Theo dõi THUỘC TÍNH value, không nghe sự kiện riêng của theme: tên sự
       kiện đổi giữa các bản Dawn, thuộc tính thì không. */
    function followMain(root) {
      var main = root.querySelector('[data-ng-main]');
      var picker = document.querySelector(
        'form[action*="/cart/add"]:not([data-ng-gift-form]) input[name="id"]');
      if (!main || !picker) return;
      var apply = function () {
        var sel = main.querySelector('[data-ng-variant]');
        if (sel && picker.value) { sel.value = picker.value; recalc(root); }
      };
      new MutationObserver(apply).observe(picker, { attributes: true, attributeFilter: ['value'] });
      picker.addEventListener('change', apply);
    }

    function init(root) {
      if (root.__ngGift) return;
      root.__ngGift = true;
      root.addEventListener('change', function () { recalc(root); });
      var form = root.querySelector('[data-ng-gift-form]');
      if (form) {
        form.addEventListener('submit', function (e) { e.preventDefault(); submit(root); });
      }
      followMain(root);
      recalc(root);
    }

    function boot() { document.querySelectorAll('[data-ng-gift]').forEach(init); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else { boot(); }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-nightgrid"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__ngBundleReady) return;
  window.__ngBundleReady = true;

  function fmt(cents, cur) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: cur || 'USD'
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function table(item) {
    if (item.__tbl) return item.__tbl;
    var el = item.querySelector('[data-ng-variants]');
    try { item.__tbl = JSON.parse(el.textContent); } catch (e) { item.__tbl = []; }
    return item.__tbl;
  }

  function current(item) {
    var hid = item.querySelector('[data-ng-variant]');
    var rows = table(item);
    for (var i = 0; i < rows.length; i++) {
      if (String(rows[i].id) === String(hid.value)) return rows[i];
    }
    return rows[0] || null;
  }

  /* Đọc các select option ra một mảng theo ĐÚNG thứ tự option của sản phẩm.
     Option chỉ có một giá trị không được in ra select, nên phải lấy giá trị
     của nó từ biến thể đang chọn, không được coi như rỗng. */
  function wanted(item) {
    var base = current(item);
    var want = base ? base.o.slice() : [];
    item.querySelectorAll('[data-ng-opt]').forEach(function (sel) {
      want[parseInt(sel.getAttribute('data-ng-opt'), 10)] = sel.value;
    });
    return want;
  }

  function resolve(item, changedIdx) {
    var rows = table(item);
    var want = wanted(item);

    var exact = rows.find(function (r) {
      return r.o.length === want.length && r.o.every(function (v, i) { return v === want[i]; });
    });
    if (exact) return exact;

    /* Combo vừa chọn không còn hàng. Giữ nguyên option khách vừa bấm, thả các
       option còn lại về cái đầu tiên còn hàng — thay vì khoá nút và bắt khách
       tự mò ra tổ hợp hợp lệ. */
    var near = rows.find(function (r) {
      return changedIdx == null || r.o[changedIdx] === want[changedIdx];
    });
    return near || rows[0] || null;
  }

  function paint(item, row) {
    if (!row) return;

    item.querySelector('[data-ng-variant]').value = row.id;

    item.querySelectorAll('[data-ng-opt]').forEach(function (sel) {
      var v = row.o[parseInt(sel.getAttribute('data-ng-opt'), 10)];
      if (v != null && sel.value !== v) sel.value = v;
    });

    var img = item.querySelector('.ng-bundle__media img');
    if (img && row.img && img.getAttribute('src') !== row.img) {
      /* PHẢI xoá srcset. Chỉ đổi src thì trình duyệt vẫn dùng ứng viên trong
         srcset cũ và ảnh không hề đổi — đúng lỗi khách báo. */
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = row.img;
    }
  }

  function sync(root, changedItem, changedIdx) {
    var cur = root.getAttribute('data-currency');
    var pct = parseInt(root.getAttribute('data-ng-pct'), 10) || 0;
    var sub = 0, picked = 0;

    root.querySelectorAll('[data-ng-item]').forEach(function (item) {
      var row = resolve(item, item === changedItem ? changedIdx : null);
      paint(item, row);
      if (!row) return;

      var nowEl = item.querySelector('[data-ng-now]');
      if (nowEl) nowEl.textContent = fmt(row.p, cur);

      if (item.hasAttribute('data-ng-main')) { sub += row.p; return; }

      var box = item.querySelector('[data-ng-addon]');
      item.classList.toggle('is-off', !box.checked);
      if (box.checked) { picked++; sub += row.p; }
    });

    var n = picked + 1;

    /* Mã chỉ áp khi giỏ đủ số món tối thiểu. Vẽ % lúc chưa đủ = hứa một con
       số mà Shopify sẽ từ chối ở checkout. */
    var min = parseInt(root.getAttribute('data-ng-min'), 10) || 1;
    var live = n >= min ? pct : 0;

    /* CÙNG công thức làm tròn với Liquid ở trên (plus: 50 | divided_by: 100).
       Lệch công thức thì con số server vẽ và con số JS vẽ đè khác nhau một
       cent, và khách kịp nhìn thấy nó nhảy. */
    var off = Math.round(sub * live / 100);

    var subEl = root.querySelector('[data-ng-sub]');
    if (subEl) subEl.textContent = fmt(sub, cur);

    var offEl = root.querySelector('[data-ng-off]');
    if (offEl) offEl.textContent = '−' + fmt(off, cur);

    var offRow = root.querySelector('[data-ng-off-row]');
    if (offRow) offRow.hidden = live === 0;

    var hintRow = root.querySelector('[data-ng-hint-row]');
    if (hintRow) {
      var need = Math.max(0, min - n);
      hintRow.hidden = !(pct > 0 && need > 0);
      if (!hintRow.hidden) {
        root.querySelector('[data-ng-hint]').textContent =
          'Add ' + need + (need === 1 ? ' more item' : ' more items') +
          ' to get ' + pct + '% off';
      }
    }

    var totalEl = root.querySelector('[data-ng-total]');
    if (totalEl) totalEl.textContent = fmt(sub - off, cur);

    var countEl = root.querySelector('[data-ng-count]');
    if (countEl) countEl.textContent = n + (n === 1 ? ' item' : ' items');
  }

  /* Danh sách dòng hàng gửi lên /cart/add.js. Đánh số lại từ 0 mỗi lần:
     nếu dựng sẵn items[0..n] rồi chỉ bỏ tích, chỉ số bị thủng (items[0],
     items[2]) và Shopify BỎ QUA phần sau lỗ hổng mà không báo lỗi gì. */
  function lines(root) {
    var out = [];
    root.querySelectorAll('[data-ng-item]').forEach(function (item) {
      var box = item.querySelector('[data-ng-addon]');
      if (box && !box.checked) return;
      var hid = item.querySelector('[data-ng-variant]');
      if (hid && hid.value) out.push({ id: Number(hid.value), quantity: 1 });
    });
    return out;
  }

  function note(root, msg) {
    var el = root.querySelector('[data-ng-note]');
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  function asJson(res) {
    if (res.ok) return res.json();
    return res.json().catch(function () { return {}; }).then(function (d) {
      throw new Error(d.description || d.message || ('HTTP ' + res.status));
    });
  }

  /* Bỏ hàng vào giỏ -> áp mã của ĐÚNG bundle này -> đọc lại giỏ để xác nhận.
     Bước xác nhận không thừa: đo trên store thật, /discount/<mã bịa> trả về
     302 sang /cart giống hệt mã thật, không lỗi, không cảnh báo. Nếu chỉ
     chuyển trang theo redirect đó thì mã gõ sai hay mã hết hạn đều đẩy khách
     sang giỏ với giá nguyên, ngay sau khi trang vừa hứa đã giảm. */
  function submit(root) {
    var form = root.querySelector('[data-ng-bundle-form]');
    var btn = form.querySelector('[data-ng-submit]');
    var code = (root.getAttribute('data-ng-code') || '').trim();
    var cartUrl = root.getAttribute('data-ng-cart') || '/cart';
    var rootUrl = root.getAttribute('data-ng-root') || '/';
    if (rootUrl.slice(-1) !== '/') rootUrl += '/';

    var items = lines(root);
    if (!items.length) return;

    var label = btn.textContent;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    note(root, '');

    var go = function () { window.location.href = cartUrl; };
    var stop = function (msg) {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.textContent = label;
      note(root, msg);
    };

    /* Chưa đủ món thì ĐỪNG áp mã. Áp vào, Shopify từ chối, rồi bước xác nhận
       bên dưới bật cảnh báo đỏ — trong khi trang chưa hề hứa giảm gì. Cảnh
       báo sai chỗ làm khách tưởng đơn hàng có vấn đề. */
    var minN = parseInt(root.getAttribute('data-ng-min'), 10) || 1;
    if (items.length < minN) code = '';

    fetch(root.getAttribute('data-ng-add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(asJson)
      .then(function () {
        if (!code) { go(); return; }

        return fetch(rootUrl + 'discount/' + encodeURIComponent(code) +
                     '?redirect=' + encodeURIComponent(cartUrl), { credentials: 'same-origin' })
          .then(function () {
            return fetch(cartUrl + '.js', { credentials: 'same-origin' }).then(asJson);
          })
          .then(function (cart) {
            var hit = (cart.discount_codes || []).some(function (d) {
              return String(d.code).toLowerCase() === code.toLowerCase();
            });
            if (hit && cart.total_discount > 0) { go(); return; }
            stop('Your items are in the cart, but the bundle discount did not apply. ' +
                 'Please review your cart before checking out.');
          });
      })
      .catch(function (e) {
        stop(e.message || 'Could not add to cart. Please try again.');
      });
  }

  /* Khách đổi màu/size ở bộ chọn chính phía trên -> dòng đầu của bundle chạy
     theo. Chiều ngược lại KHÔNG đẩy lên: bundle chỉ chịu trách nhiệm cho
     những gì chính nó bỏ vào giỏ, không giành quyền điều khiển form chính. */
  function followMain(root) {
    var main = root.querySelector('[data-ng-main]');
    var picker = document.querySelector('form[action*="/cart/add"]:not([data-ng-bundle-form]) input[name="id"]');
    if (!main || !picker) return;

    var apply = function () {
      var rows = table(main);
      var hit = rows.find(function (r) { return String(r.id) === String(picker.value); });
      if (!hit) return;
      main.querySelector('[data-ng-variant]').value = hit.id;
      sync(root);
    };
    /* Theo dõi thuộc tính value thay vì nghe sự kiện riêng của theme — tên sự
       kiện đổi giữa các bản Dawn, thuộc tính thì không. */
    new MutationObserver(apply).observe(picker, { attributes: true, attributeFilter: ['value'] });
    picker.addEventListener('change', apply);
  }

  function init(root) {
    if (root.__ngInit) return;
    root.__ngInit = true;

    root.addEventListener('change', function (e) {
      var opt = e.target.closest('[data-ng-opt]');
      if (opt) {
        sync(root, opt.closest('[data-ng-item]'), parseInt(opt.getAttribute('data-ng-opt'), 10));
      } else if (e.target.closest('[data-ng-addon]')) {
        sync(root);
      }
    });

    /* preventDefault: form không post nữa. Phải chặn vì mã chỉ áp được SAU
       khi giỏ đã có hàng, mà post thường thì trang đã rời đi mất rồi. */
    root.querySelector('[data-ng-bundle-form]')
        .addEventListener('submit', function (e) { e.preventDefault(); submit(root); });

    followMain(root);
    sync(root);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ng-bundle]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-nightgrid"]) return;
  try {
    
(function () {
  if (window.__ngCartReady) return;
  window.__ngCartReady = true;

  function boot(scope) {
    (scope || document).querySelectorAll('.ng-cart__form').forEach(function (form) {
      if (form.__ngInit) return;
      form.__ngInit = true;

      /* Có JS thì hai nút +/− tự gửi form, nên nút "Update cart" thành thừa.
         Ẩn bằng JS chứ KHÔNG bỏ khỏi HTML: khách tắt JS vẫn phải sửa được
         số lượng. */
      var upd = form.querySelector('[data-ng-update]');
      if (upd) upd.hidden = true;

      form.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-ng-step]');
        if (!btn) return;
        var box = btn.closest('.ng-cart__qty');
        var input = box.querySelector('.ng-cart__qty-input');
        var next = (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-ng-step'), 10);
        if (next < 0) next = 0;
        input.value = next;
        submitUpdate(form);
      });

      form.addEventListener('change', function (e) {
        if (e.target.closest('.ng-cart__qty-input')) submitUpdate(form);
      });
    });
  }

  /* Bấm + nhanh nhiều lần sẽ gửi nhiều request chồng nhau và giỏ nhảy loạn.
     Chờ 350ms sau cú bấm cuối rồi mới gửi. */
  function submitUpdate(form) {
    clearTimeout(form.__ngTimer);
    form.__ngTimer = setTimeout(function () {
      /* Phải kèm name="update", nếu không Shopify coi đây là submit của nút
         checkout và đẩy thẳng khách sang thanh toán khi họ chỉ đổi số lượng. */
      var flag = document.createElement('input');
      flag.type = 'hidden';
      flag.name = 'update';
      flag.value = '';
      form.appendChild(flag);
      form.submit();
    }, 350);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-gallery-nightgrid"] && !Shopify.designMode) return;
  try {
    
/* Lightbox tự viết, KHÔNG dùng lại của Dawn: lightbox Dawn buộc vào
   media-gallery của main-product và đọc product media, không nhận ảnh rời.

   Bắt sự kiện ở document (delegation) thay vì gắn vào từng nút, vì Theme
   editor dựng lại DOM của section mỗi lần sửa — gắn trực tiếp là mất handler
   ngay sau chỉnh sửa đầu tiên mà không có lỗi nào báo. */
(function () {
  if (window.__ngGalleryReady) return;
  window.__ngGalleryReady = true;

  var box, imgEl, capEl, prevBtn, nextBtn, items = [], index = 0, opener = null;

  function build() {
    if (box) return box;
    box = document.createElement('div');
    box.className = 'ng-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.hidden = true;
    box.innerHTML =
      '<button type="button" class="ng-lightbox__close" aria-label="Close">✕</button>' +
      '<button type="button" class="ng-lightbox__prev" aria-label="Previous">‹</button>' +
      '<button type="button" class="ng-lightbox__next" aria-label="Next">›</button>' +
      '<img class="ng-lightbox__img" alt="">' +
      '<p class="ng-lightbox__caption"></p>';
    document.body.appendChild(box);

    imgEl = box.querySelector('.ng-lightbox__img');
    capEl = box.querySelector('.ng-lightbox__caption');
    prevBtn = box.querySelector('.ng-lightbox__prev');
    nextBtn = box.querySelector('.ng-lightbox__next');

    box.querySelector('.ng-lightbox__close').addEventListener('click', close);
    prevBtn.addEventListener('click', function () { step(-1); });
    nextBtn.addEventListener('click', function () { step(1); });
    /* Bấm nền đen thì đóng — nhưng chỉ khi bấm trúng chính nền, không phải ảnh */
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    return box;
  }

  function show(i) {
    index = (i + items.length) % items.length;
    var el = items[index];
    imgEl.src = el.getAttribute('data-full');
    imgEl.alt = el.getAttribute('data-alt') || '';
    var cap = el.getAttribute('data-caption') || '';
    capEl.textContent = cap;
    capEl.hidden = cap === '';
    var solo = items.length < 2;
    prevBtn.hidden = solo;
    nextBtn.hidden = solo;
  }

  function step(d) { show(index + d); }

  function open(el) {
    var grid = el.closest('.nightgrid-gallery__grid');
    items = Array.prototype.slice.call(
      (grid || document).querySelectorAll('[data-ng-gallery-open]')
    );
    var at = items.indexOf(el);
    if (at < 0) { items = [el]; at = 0; }

    opener = el;
    build();
    box.hidden = false;
    /* ép trình duyệt tính layout một nhịp, nếu không transition opacity bị bỏ qua */
    void box.offsetWidth;
    box.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    show(at);
    box.querySelector('.ng-lightbox__close').focus();
  }

  function close() {
    if (!box || box.hidden) return;
    box.classList.remove('is-open');
    box.hidden = true;
    imgEl.src = '';
    document.body.style.overflow = '';
    /* trả tiêu điểm về đúng ô ảnh vừa bấm, cho người dùng bàn phím */
    if (opener && document.contains(opener)) opener.focus();
    opener = null;
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-ng-gallery-open]');
    if (el) { e.preventDefault(); open(el); }
  });

  document.addEventListener('keydown', function (e) {
    if (!box || box.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
  });

  /* Theme editor ẩn/dựng lại section — nếu section đang mở lightbox bị dựng
     lại thì opener thành node mồ côi, đóng luôn cho sạch. */
  document.addEventListener('shopify:section:unload', close);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-style-nightgrid"] && !Shopify.designMode) return;
  try {
    
/* Bảng size là thứ khách PHẢI đọc được trước khi bấm mua. Trong tab nó bị co
   còn ~50vw nên các con số gần như không đọc nổi. Mở ra modal cỡ thật.

   Dùng <dialog> gốc chứ không tự dựng: Esc để đóng, khoá tiêu điểm, và trả
   tiêu điểm về đúng chỗ cũ — đều có sẵn, không phải viết lại và không viết sai.

   Gắn sự kiện ở document chứ không ở ảnh, để khi Theme editor vẽ lại section
   thì vẫn chạy. */
(function () {
  var SRC = '.product__size-guide-image';
  var box = null;

  /* Shopify CDN nhận tham số width — xin bản to thay vì phóng bản đã co */
  function fullSize(url) {
    if (!url) return url;
    return /[?&]width=/.test(url)
      ? url.replace(/([?&]width=)\d+/, '$12400')
      : url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=2400';
  }

  function ensureBox() {
    if (box) return box;
    box = document.createElement('dialog');
    box.className = 'nightgrid-lightbox';
    box.setAttribute('aria-label', 'Size guide');
    box.innerHTML =
      '<div class="nightgrid-lightbox__bar">' +
        '<span class="nightgrid-lightbox__label">Size guide</span>' +
        '<span class="nightgrid-lightbox__tools">' +
          '<button type="button" data-ng-zoom>Zoom in</button>' +
          '<button type="button" data-ng-close aria-label="Close size guide">Close</button>' +
        '</span>' +
      '</div>' +
      '<div class="nightgrid-lightbox__stage"><img alt="Size guide, enlarged"></div>';
    document.body.appendChild(box);

    var stage = box.querySelector('.nightgrid-lightbox__stage');
    var zoomBtn = box.querySelector('[data-ng-zoom]');

    function setZoom(on) {
      box.classList.toggle('nightgrid-lightbox--zoomed', on);
      zoomBtn.textContent = on ? 'Fit to screen' : 'Zoom in';
      if (!on) { stage.scrollTop = 0; stage.scrollLeft = 0; }
    }

    zoomBtn.addEventListener('click', function () {
      setZoom(!box.classList.contains('nightgrid-lightbox--zoomed'));
    });
    stage.querySelector('img').addEventListener('click', function () {
      setZoom(!box.classList.contains('nightgrid-lightbox--zoomed'));
    });
    box.querySelector('[data-ng-close]').addEventListener('click', function () {
      box.close();
    });
    /* Bấm ra nền tối thì đóng — nhưng chỉ khi đúng là nền, không phải ảnh */
    box.addEventListener('click', function (e) {
      if (e.target === box) box.close();
    });
    box.addEventListener('close', function () { setZoom(false); });

    return box;
  }

  document.addEventListener('click', function (e) {
    var img = e.target.closest ? e.target.closest(SRC) : null;
    if (!img) return;
    e.preventDefault();
    var dlg = ensureBox();
    var big = dlg.querySelector('.nightgrid-lightbox__stage img');
    big.src = fullSize(img.currentSrc || img.src);
    if (img.alt) big.alt = img.alt + ', enlarged';
    dlg.showModal();
  });

  /* Ảnh không tự nói là nó bấm được — thêm một dòng gợi ý dưới ảnh */
  function addHint() {
    document.querySelectorAll(SRC).forEach(function (img) {
      var host = img.parentNode;
      if (!host || host.querySelector('.nightgrid-zoomhint')) return;
      var p = document.createElement('p');
      p.className = 'nightgrid-zoomhint';
      p.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
        'stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/>' +
        '<path d="M20 20l-3.5-3.5M11 8v6M8 11h6"/></svg>' +
        '<span>Tap the chart to view it full size</span>';
      host.appendChild(p);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addHint);
  } else {
    addHint();
  }
  document.addEventListener('shopify:section:load', addHint);
})();

  } catch(e) { console.error(e); }
})();
})();
